import './footer.css';

export default function Footer() {
    return (
        <>
            <footer className="contenedorPrincipalFooter">
                <div className="infoFooterContainer">
                    <p>Copyright 2024 Calvo Aluminios. Desarrollo: <a href="https://www.linkedin.com/in/juan-manuel-pizzio-2b1477262/">Juan Manuel Pizzio</a> / Diseño: <a href="https://www.instagram.com/impressa_chajari/">IMPRESSA</a> - <a href="https://www.linkedin.com/in/juan-manuel-pizzio-2b1477262/">Juan Manuel Pizzio</a></p>
                </div>
            </footer>
        </>
    );
}
